import { displayWithDecimals } from './display-with-decimals';
import { roundToDecimals } from './round-to-decimals';

export const roundAndDisplayWithDecimals =
  (decimals: number) =>
  (value: number): string | number =>
    displayWithDecimals(decimals)(roundToDecimals(decimals)(value));
